import React from "react"
import {FieldEditableMode, FieldEditableProps, FieldEditableState} from "../../../../proto/render/editable";
import {FieldViewSize} from "../../../../const";
import {TimeValue} from "../../../../../gd/types/datetime";
import {isBulkSelection} from "../../../../../gd/right-click-menu";
import DatetimeUtils from "../../../../../gd/utils/datetime-utils";
import {FieldInlineEditableProps} from "../../../../render/inline-editable";

const debug = false
// const debug = "FieldTimeOfDay_Editable"

export default class FieldTimeOfDay_InlineEditable extends React.Component<FieldInlineEditableProps,FieldEditableState> {
    constructor(props:FieldEditableProps) {
        super(props)

        this.state = {
            mode        : FieldEditableMode.VIEW
        }
    }

    get canEdit():boolean {
        if (this.props.disabled || !this.props.field.canEdit(this.props.model)) {
            return false
        }
        return true
    }

    get classes():string {
        const classes = Classes("ui5-field-editable min-w-125 min-h-36 p-l-10 p-r-10", this.props.className, {
            "ui5-txt-default"               : this.props.size === FieldViewSize.DEFAULT,
            "size-default"                  : this.props.size === FieldViewSize.DEFAULT,
            "ui5-txt-less-important-small"  : this.props.size === FieldViewSize.SMALL,
            "size-small"                    : this.props.size === FieldViewSize.SMALL,
        })
        return classes
    }

    onMouseEnter = () => {
        if (!this.canEdit) return

        if (this.state.mode === FieldEditableMode.VIEW) this.setState({
            mode   : FieldEditableMode.HOVERED
        })
    }

    onMouseLeave = () => {
        if (this.state.mode === FieldEditableMode.HOVERED) {
            this.setState({
                mode        : FieldEditableMode.VIEW
            })
        }
    }

    setValue = (value:TimeValue | null) => {

        if(!value) {
            this.props.onChange && this.props.onChange(null)
            return
        }

        const result: Moment = moment()
        result.hours(value.hours)
        result.minutes(value.minutes)
        result.seconds(0)
        result.milliseconds(0)

        // make it first (!) to update model and hidePopover will reRenbder(!)
        this.props.onChange && this.props.onChange(result)

        this.hidePopover()
    }

    onDeleteClick = async (e:React.MouseEvent)=>{
        if (isBulkSelection(e)) return
        e.stopPropagation()
        this.setValue(null)
    }

    onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        if (!this.canEdit) return

        if(this.state.mode === FieldEditableMode.EDITING){
            this.setState({
                mode     : FieldEditableMode.HOVERED
            })
        }
        else{
            this.setState({
                mode     : FieldEditableMode.EDITING
            })
        }
    }

    onOptionClick = (option:Option) => {
        this.setValue(option.value as TimeValue)
    }

    hidePopover = () => {
        this.setState({
            mode        : FieldEditableMode.VIEW
        })
    }

    renderValue() {

        let value     = this.props.field.getViewValue(this.props.model)
        const displayValue = this.props.field.getDisplayValue(value)
        const showIcon = _.get(this.props.configOptions, 'showIcon', true)

        if (!value) return (
            <div className="flex-row-left-center">
                {showIcon && <div className="ui5-ico-16 i5-my-time m-r-10"></div>}
                <div className="ui5-txt-no-accent-default w-100-percent flex-row-left-center txt-truncate">
                    {this.props.field.placeholder}
                </div>
            </div>
        )
        return (
            <div className="flex-row-left-center">
                {showIcon && <div className="ui5-ico-16 i5-my-time m-r-10"></div>}
                <div className="txt-truncate cursor-default">
                    {displayValue}
                </div>
            </div>
        )
    }

    renderEditing() {

        const field = this.props.field
        const currentValue = DatetimeUtils.dateToMoment(this.props.field.getViewValue(this.props.model))

        const classes = Classes(this.classes, "is-hovered")

        return (
            <React.Fragment>
                <div className    = {classes}
                     onMouseEnter = {this.onMouseEnter}
                     onMouseLeave = {this.onMouseLeave}
                     onClick      = {this.onClick} >

                    {this.renderValue()}

                    <div className="buttons flex-no-shrink">
                        {!!currentValue && <div className="btn-reset" onClick={this.onDeleteClick}/>}
                        <div className="btn-arrow"/>
                    </div>
                </div>
                <field.components.PopoverMenu
                    parent={this}
                    field={this.props.field}
                    model={this.props.model}
                    value={currentValue}
                    // listItem={this.props.listItem}
                    // manager={this.props.manager}
                />
            </React.Fragment>
        )
    }

    renderHovered() {

        const currentValue  = this.props.field.getViewValue(this.props.model)

        const classes = Classes(this.classes, "is-hovered")

        return (
            <div className    = {classes}
                 onClick      = {this.onClick}
                 onMouseEnter = {this.onMouseEnter}
                 onMouseLeave = {this.onMouseLeave}>

                {this.renderValue()}

                <div className="buttons flex-no-shrink">
                    {!!currentValue && <div className="btn-reset" onClick={this.onDeleteClick}/>}
                    <div className="btn-arrow"/>
                </div>
            </div>
        )
    }

    renderView() {

        return (
            <div className    = {this.classes}
                 onMouseEnter = {this.onMouseEnter}
                 onMouseLeave = {this.onMouseLeave}>

                {this.renderValue()}

            </div>
        )
    }

    render() {
        // debug && console.log(debug, "render()", this.props)
        debug && console.log(debug, "render() isHovered=", this.state.mode)


        switch (this.state.mode) {

            case FieldEditableMode.EDITING:
                return this.renderEditing()

            case FieldEditableMode.HOVERED:
                return this.renderHovered()

            default:
            case FieldEditableMode.VIEW:
                return this.renderView()
        }

    }
}
